import React from 'react';

const FilterSortModal = ({ open, onClose, sort, setSort }) => {
  if (!open) return null;
  return (
    <div className="filter-sort-modal-backdrop" onClick={onClose}>
      <div className="filter-sort-modal-content" onClick={e => e.stopPropagation()}>
        <h3>Rendezés / Szűrés</h3>
        <form>
          <div>
            <label>
              <input
                type="radio"
                name="sort"
                value="none"
                checked={sort === 'none'}
                onChange={() => setSort('none')}
              />
              Nincs rendezés
            </label>
          </div>
          <div>
            <label>
              <input
                type="radio"
                name="sort"
                value="abc"
                checked={sort === 'abc'}
                onChange={() => setSort('abc')}
              />
              ABC sorrend (Rendszám szerint)
            </label>
          </div>
          <div>
            <label>
              <input
                type="radio"
                name="sort"
                value="date"
                checked={sort === 'date'}
                onChange={() => setSort('date')}
              />
              Átadás dátuma szerint
            </label>
          </div>
          <div>
            <label>
              <input
                type="radio"
                name="sort"
                value="monthly_distance"
                checked={sort === 'monthly_distance'}
                onChange={() => setSort('monthly_distance')}
              />
              Futás szerint
            </label>
          </div>
        </form>
        <button onClick={onClose} className="filter-sort-modal-close-btn">Bezár</button>
        <button type="button" className="filter-sort-modal-close-btn" style={{marginLeft:8}} onClick={() => { setSort('none'); onClose(); }}>Szűrés törlése</button>
      </div>
    </div>
  );
};

export default FilterSortModal; 